<script setup lang="ts"></script>

<template>
	<footer
		class="sticky top-[100vh] pr-3 py-1 text-white/50 text-[10px] text-end">
		<router-link :to="'/imprint-tos'" class="hover:cursor-pointer">
			Imprint & Terms of Service
		</router-link>
	</footer>
</template>
